// extracted by mini-css-extract-plugin
module.exports = {"container":"TakeCareTabItem_container__32EnX","contentText":"TakeCareTabItem_contentText__1K1kz"};